import React, { useEffect } from "react";
import './css/policy.css'



const Privacy = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="policy-body">
            <h2>Privacy Policy</h2>

            <p>Effective Date 30-Sep-2022</p>
            <p>Last Updated On 30-Sep-2022</p>
            <p>This Privacy Policy describes the policies of

                Bastard Cards, 29 The West Hundreds, Hampshire GU51 1ER, United Kingdom of Great Britain and Northern Ireland (the), email: hello@bastardcards.com, phone: 01632 960286on the collection, use and disclosure of your information that we collect when you use our website ( https://bastardcards.com ). (the “Service”). By accessing or using the Service, you are consenting to the collection, use and disclosure of your information in accordance with this Privacy Policy. If you do not consent to the same, please do not access or use the Service.
                We may modify this Privacy Policy at any time without any prior notice to you and will post the revised Privacy Policy on the Service. The revised Policy will be effective 180 days from when the revised Policy is posted in the Service and your continued access or use of the Service after such time will constitute your acceptance of the revised Privacy Policy. We therefore recommend that you periodically review this page.
            </p>
            <h3>Information We Collect:</h3>
            <p>We will collect and process the following personal information about you:
            </p>
            <ul>

                <li>Name</li>
                <li>Email</li>
                <li>Mobile</li>
                <li>Date of Birth</li>
                <li>Address</li>
                <li>Payment Info</li>
            </ul>
            <h3>How We Collect Your Information:</h3>
            <p>We collect/receive information about you in the following manner:
            </p>
            <ul>
                <li>When a user fills up the registration form or otherwise submits personal information</li>
                <li>Interacts with the website</li>
                <li>From public sources</li>

            </ul>
            <h3>How We Use Your Information:</h3>
            <p>We will use the information that we collect about you for the following purposes:
            </p>
            <ul>
                <li>Marketing/ Promotional</li>
                <li>Creating user account</li>
                <li>Testimonals</li>
                <li>Customer feedback collection</li>
                <li>Enforce T&C</li>
                <li>Processing payment</li>
                <li>Support</li>
                <li>Administration info</li>
                <li>Targeted advertising</li>
                <li>Manage customer order</li>
                <li>Site protection</li>
                <li>User to user comments</li>
                <li>Dispute resolution</li>
                <li>Manage user account</li>

            </ul>
            <p>If we want to use your information for any other purpose, we will ask you for consent and will use your information only on receiving your consent and then, only for the purpose(s) for which grant consent unless we are required to do otherwise by law.
            </p>

            <h3>How We Share Your Information:</h3>
            <p>We will not transfer your personal information to any third party without seeking your consent, except in limited circumstances as described below:
            </p>
            <ul>
                <li>Ad service</li>
                <li>Sponsors</li>
                <li>Marketing agencies</li>
                <li>Legal entities</li>
                <li>Analytics</li>
                <li>Data collection & process</li>

            </ul>
            <p>We require such third party’s to use the personal information we transfer to them only for the purpose for which it was transferred and not to retain it for longer than is required for fulfilling the said purpose.

                We may also disclose your personal information for the following: (1) to comply with applicable law, regulation, court order or other legal process; (2) to enforce your agreements with us, including this Privacy Policy; or (3) to respond to claims that your use of the Service violates any third-party rights. If the Service or our company is merged or acquired with another company, your information will be one of the assets that is transferred to the new owner.
            </p>
            <h3>Retention Of Your Information:</h3>
            <p>We will retain your personal information with us for 90 days to 2 years after user accounts remain idle or for as long as we need it to fulfill the purposes for which it was collected as detailed in this Privacy Policy. We may need to retain certain information for longer periods such as record-keeping / reporting in accordance with applicable law or for other legitimate reasons like enforcement of legal rights, fraud prevention, etc. Residual anonymous information and aggregate information, neither of which identifies you (directly or indirectly), may be stored indefinitely.
            </p>
            <h3>Your Rights:</h3>
            <p>Depending on the law that applies, you may have a right to access and rectify or erase your personal data or receive a copy of your personal data, restrict or object to the active processing of your data, ask us to share (port) your personal information to another entity, withdraw any consent you provided to us to process your data, a right to lodge a complaint with a statutory authority and such other rights as may be relevant under applicable laws. To exercise these rights, you can write to us at hello@bastardcards.com. We will respond to your request in accordance with applicable law.

                You may opt-out of direct marketing communications or the profiling we carry out for marketing purposes by writing to us at hello@bastardcards.com.

                Do note that if you do not allow us to collect or process the required personal information or withdraw the consent to process the same for the required purposes, you may not be able to access or use the services for which your information was sought.
            </p>
            <h3>Cookies Etc.</h3>
            <p>To learn more about how we use these and your choices in relation to these tracking technologies, please refer to our Cookie Policy.
            </p>
            <h3>Security:</h3>
            <p>The security of your information is important to us and we will use reasonable security measures to prevent the loss, misuse or unauthorized alteration of your information under our control. However, given the inherent risks, we cannot guarantee absolute security and consequently, we cannot ensure or warrant the security of any information you transmit to us and you do so at your own risk.
            </p>

            <h3>Grievance / Data Protection Officer:</h3>
            <p>If you have any queries or concerns about the processing of your information that is available with us, you may email our Grievance Officer at Bastard Cards, 29 The West Hundreds, email: hello@bastardcards.com. We will address your concerns in accordance with applicable law.
            </p>

        </div>
    );
};

export default Privacy;
